import { render, staticRenderFns } from "./RecipientInActiveReason.vue?vue&type=template&id=54c0d44d"
import script from "./RecipientInActiveReason.vue?vue&type=script&lang=js"
export * from "./RecipientInActiveReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports